import {
  SET_LOADING,
  LOGOUT,
  SAVE_QUESTION_FAILURE,
  SAVE_QUESTION_SUCCESS,
  SAVE_RESET,
  GET_QUESTION_SUCCESS,
  GET_QUESTION_FAILURE,
} from './types';

const initialState = {
  questions: [],
  saveStatus: false,
  error: null,
  isLoading: false,
};

const questionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_QUESTION_SUCCESS:
      return {
        ...state,
        saveStatus: true,
        isLoading: false,
      };
    case SAVE_QUESTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case GET_QUESTION_SUCCESS:
      return {
        ...state,
        questions: action.payload,
        isLoading: false,
      };
    case GET_QUESTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case SAVE_RESET:
      return {
        ...state,
        saveStatus: false
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default questionReducer;
